const NPS_BANNER_LOCAL_STORAGE_KEY = 'show-nps-banner-2';
export const NPS_LINK =
  'https://docs.google.com/forms/d/e/1FAIpQLSfCaFSxejd1Kd2M9zdIlDnCyFPHmg0ntmajJJTZq2rabriMJw/viewform?usp=sharing&ouid=100557232434529249608';
const NPS_BANNER_ACTIVE = false;

export const getNPSBannerStatus = () => {
  if (!NPS_BANNER_ACTIVE) return false;

  const ls = localStorage.getItem(NPS_BANNER_LOCAL_STORAGE_KEY);
  ls === null && setNPSBannerStatus(true);

  return Boolean(ls === 'true' || ls === null);
};

const setNPSBannerStatus = (bool: boolean) => {
  localStorage.setItem(NPS_BANNER_LOCAL_STORAGE_KEY, JSON.stringify(bool));
};

export const hideNPSBanner = () => {
  setNPSBannerStatus(false);
};
